import React from "react";
import {TableCell} from "@/shared/components/ui/table";
import {Cell, flexRender} from "@tanstack/react-table";

export function ReactTableCell<TData>({cell}: { cell: Cell<TData, unknown> }) {
    const columnSize = cell.column.getSize();

    return (
        <TableCell
            key={cell.id}
            style={{
                width: columnSize,
                flex: `0 0 ${columnSize}px`,
                boxSizing: "border-box",
            }}
        >
            <span
                className="block min-w-0 max-w-full truncate whitespace-nowrap text-left text-sm text-gray-800">
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </span>
        </TableCell>
    );
}

